module.exports = __webpack_public_path__ + "static/media/image.1d26323b.png";